import CircularProgress from "@mui/material/CircularProgress";
import Typography from "@mui/material/Typography";

const Loading = () => {
	return (
		<div className="flex flex-col w-full justify-center">
			<Typography className="h2 mx-12 font-medium" color="textSecondary">
				Loading...
			</Typography>
			<CircularProgress />
		</div>
	);
};

export default Loading;
